import React from 'react'

// import { useTranslation } from 'react-i18next'

import { usePageTitle } from '../../hooks/usePageTitle'
import FilterSection from './_component/FilterSection'
import { Body, Container } from './style'
import { PageProps } from '@/@types/global'

const Approver: React.FC<PageProps> = ({ title, subtitle }) => {
  // const { t } = useTranslation()

  usePageTitle({ title, subtitle })

  return (
    <Container>
      <FilterSection />
    </Container>
  )
}

export default Approver
